import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Button,
  Card,
  IconButton,
  Modal,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";

export interface ModalProps {
  onClose: () => void;
  open: boolean;
}

interface BasicModalProps extends ModalProps {
  cancelText?: string;
  children: React.ReactNode;
  formId?: string;
  loading?: boolean;
  modalSx?: SxProps;
  onSubmit?: () => void;
  submitText: string;
  sx?: SxProps;
  title: string;
  disabled?: boolean;
}

const BasicModal = ({
  cancelText,
  children,
  formId,
  loading = false,
  modalSx,
  open,
  onClose,
  onSubmit,
  submitText,
  sx,
  title,
  disabled = false,
}: BasicModalProps) => {
  return (
    <Modal open={open} onClose={onClose} disableAutoFocus sx={modalSx}>
      <Card
        sx={{
          ...sx,
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: "95%",
          maxHeight: "95%",
          p: 2,
          px: 3,
        }}
      >
        <Stack>
          <Typography
            variant="h2"
            sx={{ mb: 2, mt: 0.5, color: "shades.neutral.700", pr: 4 }}
          >
            {title}
          </Typography>
          <IconButton
            sx={{ position: "absolute", right: 15, top: 15 }}
            onClick={onClose}
          >
            <CloseIcon
              sx={{ fill: "#323232", height: "20px", width: "20px" }}
            />
          </IconButton>
          {children}
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={2}
            sx={{ mt: 2 }}
          >
            <Button
              onClick={onClose}
              sx={{ py: 0.5, px: 1.5, height: "46px", minWidth: "100px" }}
            >
              {cancelText ?? "Cancel"}
            </Button>
            <LoadingButton
              type="submit"
              form={formId}
              variant="contained"
              loading={loading}
              onClick={onSubmit}
              sx={{ py: 0.5, px: 1.5, height: "46px", minWidth: "144px" }}
              disabled={disabled}
            >
              {submitText}
            </LoadingButton>
          </Stack>
        </Stack>
      </Card>
    </Modal>
  );
};

export default BasicModal;
